import { render, staticRenderFns } from "./notificationsComponent.vue?vue&type=template&id=2a574fb0&scoped=true&"
import script from "./notificationsComponent.vue?vue&type=script&lang=js&"
export * from "./notificationsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a574fb0",
  null
  
)

export default component.exports